import { injectIntl } from 'react-intl';

import DashboardComplexFilters from './DashboardComplexFilters';

export default injectIntl(DashboardComplexFilters);
